(function () {
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const AVAIN = '_jaettu';

  async function haeJaettu() {
    const html = await (await fetch(ROOT + '?section_id=split-shipping')).text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.getElementById('jaettu-data');
    return el ? JSON.parse(el.textContent).jaettu : false;
  }

  async function paivitaJaettu() {
    let cart = await (await fetch(ROOT + 'cart.js')).json();
    if (!cart.items.length) return;

    const arvo = (await haeJaettu()) ? 'kylla' : 'ei';

    // Päivitetään rivit yksi kerrallaan, koska rivin key muuttuu
    for (let i = 0; i < 50; i++) {
      const rivi = cart.items.find(it => (it.properties || {})[AVAIN] !== arvo);
      if (!rivi) break;

      const res = await fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: rivi.key,
          quantity: rivi.quantity,
          properties: Object.assign({}, rivi.properties || {}, { [AVAIN]: arvo })
        })
      });
      if (!res.ok) throw new Error('cart/change epäonnistui');
      cart = await res.json();
    }
  }

  let kaynnissa = false;

  document.addEventListener('click', async function (e) {
    const nappi = e.target.closest(
      'button[name="checkout"], input[name="checkout"], a[href*="/checkout"]'
    );
    if (!nappi || kaynnissa) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    kaynnissa = true;
    nappi.setAttribute('aria-busy', 'true');
    nappi.disabled = true;

    try {
      await paivitaJaettu();
    } catch (err) {
      console.error('Jaettu-tarkistus epäonnistui:', err);
    }
    window.location.href = ROOT + 'checkout';
  }, true);
})();